import { render, staticRenderFns } from "./singin.vue?vue&type=template&id=418fe85d"
import script from "./singin.vue?vue&type=script&lang=js"
export * from "./singin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports